import { defineTransform, JsonResponse, Nullable } from '@client/core/data/concerns/parses-from-json';
import { parseISO } from '@client/core/utils/date';

export class SaleHistory {
  constructor(
    public readonly recordingDate: Nullable<Date>,
    public readonly bookNumber: Nullable<string>,
    public readonly buyers: Nullable<string>,
    public readonly documentNumber: Nullable<string>,
    public readonly documentType: Nullable<string>,
    public readonly pageNumber: Nullable<string>,
    public readonly salePrice: Nullable<number>,
    public readonly sellers: Nullable<string>,
  ) {}
}

defineTransform(SaleHistory, (json: JsonResponse, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    recordingDate: nullOr(json.recording_date, () => parseISO(json.recording_date)),
  };
});
